import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import "./registerServiceWorker";
import "./styles/main.sass";
import "./styles/global.css";
import { version } from "../package.json";
import domain from "./plugins/plugin-domain";
import permissions from "./plugins/plugin-permissions";
import Agent from "./plugins/plugin-agent";
import axios from "./plugins/plugin-axios";
import formdata from "./plugins/plugin-formdata";
import date from "./plugins/plugin-date";
import login from "./plugins/plugin-login";
import logout from "./plugins/plugin-logout";
import infotable from "./plugins/plugin-infotable";
import bet from "./plugins/plugin-bet";
import print from "./plugins/plugin-print";
import money from "v-money";
import VueMask from "v-mask";
import treatOdd from "./plugins/plugin-treat-odd";
import selectOdd from "./plugins/plugin-select-odd";
import VueProgressBar from "vue-progressbar";
// import VueNativeSock from 'vue-native-websocket'
import OperatorOnline from "./plugins/plugin-credit-online";
import Copy from "./plugins/plugin-copy";
import handleURLState from "./plugins/plugin-handle-url-state";
import RangeDate from "./plugins/date";
import OperatorRetail from "./plugins/plugin-operator-retail";
import i18n from "@/plugins/i18n";
import gmt from "./plugins/plugin-gmt";
import request from "./plugins/request";
import VueCryptojs from "vue-cryptojs";
import utils from "./plugins/plugin-utils";
import GroupExport from "./plugins/plugin-export";
import gtag from "./plugins/gtag";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
// import integrations from "./plugins/plugin-integrations";
import activeCampaign from "./plugins/integrations/activeCampaign";
import webhook from "./plugins/integrations/webhook";
import zendesk from "./plugins/integrations/zendesk";
import rdStation from "./plugins/integrations/rdStation";
import lgaming from "./plugins/integrations/lgaming";
import localbase from "./plugins/plugin-localbase";
import OtpInput from "@bachdgvn/vue-otp-input";

Vue.use(domain)
  .use(permissions)
  // .use(VueI18n)
  .use(Agent)
  .use(axios)
  .use(request)
  .use(formdata)
  .use(date)
  .use(login)
  .use(logout)
  .use(infotable)
  .use(gmt)
  .use(bet)
  .use(print)
  .use(money)
  .use(VueMask)
  .use(treatOdd)
  .use(selectOdd)
  .use(VueProgressBar, {
    color: "#2196F3",
    failedColor: "#FF5252",
    thickness: "3px",
  })
  .use(OperatorOnline)
  .use(RangeDate)
  .use(OperatorRetail)
  .use(gmt)
  .use(VueCryptojs)
  .use(Copy)
  .use(handleURLState)
  .use(GroupExport)
  .use(gtag)
  .use(activeCampaign)
  .use(webhook)
  .use(zendesk)
  .use(rdStation)
  .use(lgaming)
  .use(localbase)
  .use(utils); // Sempre o último

Vue.config.productionTip = false;
// Remove devtools da produção
Vue.config.devtools = false;
Vue.config.performance = true;

Vue.component("DynamicScroller", DynamicScroller);
Vue.component("DynamicScrollerItem", DynamicScrollerItem);
Vue.component("v-otp-input", OtpInput);

// Config Objects GLOBAIS:
Vue.prototype.$now = new Date().toISOString().substr(0, 10);
Vue.prototype.$sports = {
  "10": "Especiais",
  "6046": "Futebol",
  "100": "Vencedor",
  "48242": "Basquete",
  "54094": "Tênis",
  "154919": "UFC/Boxe",
  "687890": "E-Sports",
  "154830": "Vôlei",
  "52": "Um Pra Um",
  "687887": "Futsal",
  "53": "Futevôlei",
  "54": "Especiais",
};
Vue.prototype.$invertSports = {
  Especiais: "10",
  Basquete: "48242",
  Baloncesto: "48242",
  Basketball: "48242",
  "E-Sports": "687890",
  Futebol: "6046",
  Fútbol: "6046",
  Soccer: "6046",
  Tênis: "54094",
  Tenis: "54094",
  Tennis: "54094",
  "UFC/Boxe": "154919",
  "UFC/Boxeo": "154919",
  "UFC/Boxing": "154919",
  Vôlei: "154830",
  Voleo: "154830",
  Volley: "154830",
  "Um Pra Um": "52",
  "Cara A Cara": "52",
  "One To One": "52",
  Futsal: "687887",
  "Fútbol Sala": "687887",
  Futevôlei: "53",
  Futvóley: "53",
  Footvolley: "53",
  Especiais: "54",
  Especiales: "54",
  Specials: "54",
  Vencedor: "10",
  Ganador: "10",
  Winner: "10",
};

new Vue({
  i18n,
  vuetify,
  router,
  store,
  money,
  data: () => ({}),
  mounted() {
    const auth = localStorage.getItem("auth");
    if (auth === "true") {
      const token = this.$store.state.logged.token;
      this.$axios.defaults.headers.common["Application-Authorization"] = token;
    }
    this.checkAppVersion();
  },
  watch: {},
  methods: {
    checkAppVersion: function () {
      const appVersionVuex = this.$store.getters.appVersionVuex;
      if (appVersionVuex == null || appVersionVuex != version) {
        localStorage.clear();
        this.$store.commit("appVersionVuex", version);
        console.log("Version App: ", appVersionVuex, " => ", version);
      } else {
        console.log("Version App:", version);
      }
    },
  },
  render: (h) => h(App),
}).$mount("#app");
// change other locale
